// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
/**
 * @hidden
 */

var DropClueVue2 = {
  data: function data() {
    return {
      height: 0,
      visible: false,
      left: 0,
      top: 0
    };
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    return this.visible && h("div", {
      "class": "k-grouping-dropclue",
      style: {
        zIndex: 10000,
        display: 'block',
        top: this.top + 'px',
        left: this.left + 'px',
        height: this.height + 'px'
      }
    });
  }
};
/**
 * @hidden
 */

var DropClue = DropClueVue2;
export { DropClue, DropClueVue2 };